import { compose } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { isEUNonBusinessStore, storeActive } from 'ggApp/modules/store';

import { CategoryList } from './CategoryList';

const enhance = compose(
    connect(
        createStructuredSelector({
            isEUNonBusinessStore,
            storeActive,
        }),
    ),
);

export default enhance(CategoryList);
